import { applyMiddleware, compose, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import reducers from '../reducers/index';
import rootSaga from '../sagas/index';
import { createServiceRegistry, resolveInitialTransport } from '../pluginAdmin/serviceRegistry';

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

// Use bridge transport automatically on the embedded production shell path.
// resolveInitialTransport() returns 'bridge' when appInIframe()=true and the
// path is not /embedded/dev.  On the bridge path, embeddedBridge=true activates
// the fail-fast guard so any accidental legacy API call throws in dev/test.
const initialTransport = resolveInitialTransport();
const serviceRegistry = createServiceRegistry({
  transport: initialTransport,
  embeddedBridge: initialTransport === 'bridge',
});
const thunkMiddleware = thunk.withExtraArgument({ serviceRegistry });

const middlewares = [thunkMiddleware, sagaMiddleware, routeMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState) {
  const store = createStore(
    reducers(history),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
export { history };
export { serviceRegistry };
